(() => {
  function init(root) {
    root.querySelectorAll('.typ-info-footer__menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const desktop = window.matchMedia('(min-width:768px)');
      const sync = () => { menu.open = desktop.matches; };
      sync();
      desktop.addEventListener('change', sync);
      menu.querySelector('summary').addEventListener('click', event => {
        if (desktop.matches) event.preventDefault();
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
